import React from "react";
import moment from "moment";
import { get } from "lodash";
import { Div, Text, Row, Col, Image, StyleReset } from "atomize";

import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import PrimaryButton from "../common/PrimaryButton";
import AnimateLink from "../common/AnimateLink";

class ResourcesFeatured extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { featuredBlog, isStory } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <AnimateLink to={`/blog/${featuredBlog.slug}`}>
            <Div d="flex" flexDir={{ xs: "column", md: "row" }}>
              <Div
                bgImg={
                  isStory
                    ? featuredBlog.featured_image.data.url
                    : featuredBlog.thumbnail.file.url
                }
                bgSize="cover"
                bgPos="center"
                flexGrow="1 1 50%"
                p={{ b: { xs: "34%", md: "49%" } }}
              ></Div>
              <Div
                flexGrow="1 1 50%"
                bg="white"
                textAlign="center"
                d="flex"
                flexDir="column"
                align={{ xs: "flex-start", sm: "center" }}
                justify="center"
                textColor="black"
                p={{
                  xs: "1rem",
                  sm: "2rem",
                  md: "4.75rem 3rem 2.5rem",
                }}
              >
                <Div maxW={{ xs: "100%", sm: "23rem", xl: "28rem" }}>
                  <Div
                    d={{ xs: "none", sm: "inline-block" }}
                    bg="gradient"
                    textColor="white"
                    textAlign="center"
                    p="5px 6px 3px"
                    m={{ b: { xs: "1rem", md: "1.75rem" } }}
                    textWeight="700"
                    textSize="tiny"
                    textTransform="uppercase"
                    rounded="xs"
                  >
                    Featured
                  </Div>
                  <Text
                    textWeight="700"
                    textAlign={{ xs: "left", sm: "center" }}
                    textSize={{
                      xs: "subheader2",
                      md: "title2",
                      //xl: "display1",
                    }}
                  >
                    {featuredBlog.title}
                  </Text>
                  <Text
                    d={{ md: "none" }}
                    m={{ t: "2rem" }}
                    style={{ letterSpacing: "1.5px" }}
                    textSize="tiny"
                    textWeight="700"
                    textAlign={{ xs: "left", sm: "center" }}
                  >
                    {isStory
                      ? get(featuredBlog, "categories.data.0..name")
                      : featuredBlog.label}{" "}
                    |{" "}
                    {moment(
                      isStory
                        ? featuredBlog.published_at
                        : featuredBlog.publishedAt
                    ).format("MMMM Do YYYY")}
                  </Text>
                  <Text
                    d={{ xs: "none", md: "block" }}
                    textSize={{ xs: "body", md: "caption2" }}
                    m={{ t: "1rem" }}
                    textWeight="500"
                    style={{ lineHeight: "24px" }}
                  >
                    {isStory
                      ? featuredBlog.custom_fields.data.find(
                          field => field.name === "seoDescription"
                        ).value
                      : featuredBlog.description}
                  </Text>

                  <PrimaryButton
                    d={{ xs: "none", md: "block" }}
                    bg="transparent"
                    hoverBg="gray400"
                    textColor="black"
                    borderColor="black50"
                    textSize="tiny"
                    h="1.7rem"
                    m="2.25rem auto 0"
                    style={{ letterSpacing: "1.5px" }}
                  >
                    Read More
                  </PrimaryButton>
                </Div>
              </Div>
            </Div>
          </AnimateLink>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}

export default ResourcesFeatured;
